export const theme = {
  sm: {
    maxWidth: "768px",
    sidebarWidth: "100%",
    sidebarHeight: "50%",
    fontSize: "2.8vw",
    lineHeight: "4vw",
    padding: "35px",
    hideMenu: true,
  },
  lg: {
    maxWidth: "992px",
    sidebarWidth: "35%",
    sidebarHeight: "100%",
    fontSize: "0.8em",
  },
  xl: {
    maxWidth: "1200px",
    sidebarWidth: "35%",
    sidebarHeight: "100%",
    fontSize: "1.1em",
  },
}

export const colors = {}

export const sidebarWidth = 500
export const contentSidePadding = 50
